import React from 'react';
import LogoImage from '../assets/img/starlife_logo_new_trans.png'; // Import the logo
import StarLifeBg from '../assets/img/starlife_bg.png'; // Ensure this is the correct path to your background image

const AuthLayout = ({ children }) => {
  return (
    <div
      className="flex min-h-screen min-h-dvh w-full flex-col overflow-x-hidden"
      style={{
        backgroundImage: `url(${StarLifeBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <header className="relative z-10 px-3 pt-3 sm:px-5 sm:pt-4">
        <img
          src={LogoImage}
          alt="Logo"
          className="w-20 sm:w-24 md:w-28 lg:w-36"
        />
      </header>

      <main className="relative z-10 flex w-full flex-1 items-center justify-center px-3 py-5 sm:px-6 sm:py-8">
        {children}
      </main>

      <footer className="relative z-10 px-3 pb-3 text-xs text-white sm:px-5 sm:pb-4">
        © {new Date().getFullYear()} StarLife Assurance
      </footer>

    </div>
  );
};

export default AuthLayout;
